import PropTypes from "prop-types";
import { Button } from "@mui/material";
import { useEffect } from "react";

export default function UploadButton({
  accept,
  children,
  color = "secondary",
  name,
  onUpload,
  register,
  sx,
  value,
  variant = "contained",
}) {
  useEffect(() => {
    if (value) {
      onUpload();
    }
  }, [onUpload, value]);

  return (
    <label>
      <input
        accept={accept}
        name={name}
        style={{ display: "none" }}
        type="file"
        {...register(name)}
      />
      <Button color={color} component="span" sx={sx} variant={variant}>
        {children}
      </Button>
    </label>
  );
}

UploadButton.propTypes = {
  accept: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  name: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  sx: PropTypes.object,
  value: PropTypes.object,
  variant: PropTypes.string,
};
